import { map } from 'es-toolkit/compat';
import { type FC, useMemo } from 'react';
import { Dropdown } from 'react-bootstrap';
import { classes, stylesheet } from 'typestyle';
import type { SidebarDropdownProps } from '../campaign.types';
import { SidebarButton } from './SidebarButton';

const css = stylesheet({
  dropdown: {
    width: 200,
  },
});

export const SidebarDropdown: FC<SidebarDropdownProps> = ({ menuItems, label, icon, disabled = false, id, title, menuItemClicked }) => {
  const menuItem = menuItems[0];
  const visibleMenuItems = useMemo(
    () => menuItems.filter((menuItem) => (menuItem.visible === undefined ? true : menuItem.visible)),
    [
      menuItems,
    ],
  );
  if (!menuItems.length) return null;
  return menuItems.length > 1 ? (
    <Dropdown className={css.dropdown} data-cy="preview-in-symphony-menu" title={title}>
      <Dropdown.Toggle className="pod-menu-item w-100 text-left" disabled={disabled} variant="sidebar">
        {label}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {map(visibleMenuItems, (menuItem) => (
          <Dropdown.Item
            className={menuItem.cssClass}
            data-cy={menuItem.id}
            disabled={menuItem.disabled}
            key={menuItem.id}
            onClick={() => menuItemClicked(menuItem)}
            title={menuItem.title}
          >
            {menuItem.icon && <i className={classes(menuItem.icon, 'pr-2')} />}
            {menuItem.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  ) : (
    <SidebarButton
      className="btn btn-sidebar w-100 text-left pod-menu-item"
      data-cy={id}
      disabled={disabled}
      icon={icon}
      label={label}
      onClick={() => menuItemClicked(menuItem)}
      title={title}
    />
  );
};
